import React from 'react';
import { useSelector } from 'react-redux';
import Badge from './Badge';
import styles from './StatusBadges.module.scss';
import imageStrike from '@ingka/ssr-icon/paths/image-strikethrough';
import { selectIsGlobalMarket } from '../../store/slices/intl';

export const InvalidImageBadge: React.FC<{
  compact?: boolean;
  showTooltip?: boolean;
}> = ({ compact = false, showTooltip = true }) => {
  const isGlobal = useSelector(selectIsGlobalMarket);
  const label = isGlobal ? 'Invalid image' : 'Invalid product image';

  return (
    <Badge
      tooltip={label}
      iconPath={imageStrike}
      label={label}
      compact={compact}
      className={styles.invalidimage}
      showTooltip={showTooltip}
    />
  );
};
